import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

export const StyledCardContainer = styled.div<HTMLAttributes<HTMLDivElement> & {
  height?: string;
  padding?: string;
  fontSize?: string;
  backgroundColor?: string;
  minHeight?: string;
  display?: string;
  alignItems?: string;
  cursor?: string;
  borderColor?: string;
  focusBorderColor?: string;
  hoverBorderColor?: string;
  borderRadius?: string;
  textColor?: string;
  disabled?: boolean;
}>`
  .StripeElement {
    width: 100%;
    padding: ${({ padding }) => padding || '8px 11px'};
    font-size: ${({ fontSize }) => fontSize || '16px'};
    background-color: ${({ backgroundColor }) => backgroundColor || '#ffffff'};
    border: 1px solid ${({ borderColor }) => borderColor || '#d9d9d9'};
    border-radius: ${({ borderRadius }) => borderRadius || '4px'};
    transition: all 0.3s;
    min-height: 40px;
    height: ${({ height }) => height || 'auto'};
    color: ${({ textColor }) => textColor || 'black'};
    ${({ disabled }) => disabled && 'opacity: 0.5;'}
    
    &:hover {
      border-color: ${({ hoverBorderColor }) => hoverBorderColor || '#4096ff'};
      box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
    }
    
    &--focus {
      border-color: ${({ focusBorderColor }) => focusBorderColor || '#4096ff'};
      box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
      outline: 0;
    }
    
    &--invalid {
      border-color: #ff4d4f;
    }
  }

  .saved-card-info {
    width: 100%;
    padding: ${({ padding }) => padding || '8px 11px'};
    font-size: ${({ fontSize }) => fontSize || '16px'};
    background-color: ${({ backgroundColor }) => backgroundColor || '#ffffff'};
    border: 1px solid ${({ borderColor }) => borderColor || '#d9d9d9'};
    border-radius: 2px;
    transition: all 0.3s;
    min-height: 40px;
    display: flex;
    align-items: center;
    height: ${({ height }) => height || 'auto'};
    color: ${({ textColor }) => textColor || 'black'};

    &:hover {
      border-color: ${({ hoverBorderColor }) => hoverBorderColor || '#4096ff'};
      box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
    }
  }
`; 